<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">List Certificates</h3>
    <v-layout>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="#007CA4"
            dark
            @click="validate"
        >Certificate List >></v-btn>
      </v-flex>
      <v-flex md10 style="background-color: white">
        <vue-json-pretty :path="'res'" :data=this.result> </vue-json-pretty>
      </v-flex>

    </v-layout>
  </v-form>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'

  export default  {
    components: {
      VueJsonPretty,
    },
    data: () => ({
      certificateList: null,
      valid: true,
      result: ''
    }),
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      validate () {
        if (this.$refs.form.validate()) {
          this.getCertificateList()
        }
      },
      getCertificateList() {
          alisonJS.certificateList().then((cert) => {
              this.setColor('success')
              this.setSnack('Certificates obtained successfully')
              this.result = cert
              this.certificateList = JSON.stringify(cert, null, "\t");
              let certificates = cert.certificates
              this.$emit('enableTab', ['Sign'])
              this.$emit('setCertificateList', certificates)
          }).catch((e)=>{
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.certificateList = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
<style scoped  lang='css'>
  .v-expansion-panel-header{
    background-color: #007CA4;
  }
</style>